// extracted by mini-css-extract-plugin
export default {"Input":"SearchInput_Input__AJ7XX","Input__container":"SearchInput_Input__container__VK3ac","Input__icon":"SearchInput_Input__icon__S89d9"};